import { CheckResResultPage, LayoutState } from "../types/types"

export const createCloudIcon = (color: string = 'var(--gray-500, #A0AEC0)') => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('viewBox', '0 0 24 24')
    svg.setAttribute('fill', 'none')
    svg.setAttribute('width', '24')
    svg.setAttribute('height', '24')

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttribute('d', 'M12 10C12.2761 10 12.5261 10.1119 12.7071 10.2929L15.7071 13.2929C16.0976 13.6834 16.0976 14.3166 15.7071 14.7071C15.3166 15.0976 14.6834 15.0976 14.2929 14.7071L13 13.4142V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V13.4142L9.70711 14.7071C9.31658 15.0976 8.68342 15.0976 8.29289 14.7071C7.90237 14.3166 7.90237 13.6834 8.29289 13.2929L11.2929 10.2929C11.4739 10.1119 11.7239 10 12 10ZM13 2C17.1549 2 20.57 5.16745 20.9624 9.2194C22.7458 9.85449 24 11.5454 24 13.5C24 15.7461 22.345 17.6393 20.1416 17.9545C20.2565 17.9624 20.2094 17.9664 20.0005 17.9666C19.4482 17.9668 19.0003 17.5194 19 16.9671C18.9997 16.4148 19.4472 15.9668 19.9995 15.9666L19.9277 15.966C19.7143 15.9656 19.3509 15.9649 19.9226 15.9646C21.1121 15.7628 22 14.7256 22 13.5C22 12.2529 21.0774 11.1899 19.8382 10.9868C19.3548 10.9076 19 10.4899 19 10C19 6.68629 16.3137 4 13 4C10.3062 4 7.9636 5.79122 7.23189 8.34152C7.09114 8.8321 6.60354 9.13796 6.1006 9.05117C5.9039 9.01722 5.70327 9 5.5 9C3.567 9 2 10.567 2 12.5C2 14.2705 3.32185 15.7545 5.05831 15.9725L5.01623 15.9705C5.56851 15.9702 6.01647 16.4177 6.01676 16.97C6.01705 17.5223 5.56958 17.9702 5.01729 17.9706C4.97156 17.9706 4.92917 17.9692 4.89012 17.9665C2.11768 17.66 0 15.3103 0 12.5C0 9.46243 2.46243 7 5.5 7L5.58124 7.00059C6.78365 4.02407 9.69291 2 13 2Z')
    path.setAttribute('fill', color)
    path.setAttribute('fill-rule', 'evenodd')
    path.setAttribute('clip-rule', 'evenodd')

    svg.append(path)
    return svg
}

export const createTimeIcon = (color: string = 'var(--gray-500, #A0AEC0)') => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('viewBox', '0 0 24 24')
    svg.setAttribute('fill', 'none')
    svg.setAttribute('width', '24')
    svg.setAttribute('height', '24')

    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g')
    g.setAttribute('clip-path', "url(#clip0_4795_12551)")

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttribute('d', 'M12.5 8V12L15.5 14M12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 17.5228 18.0228 22 12.5 22Z')
    path.setAttribute('stroke', color)
    path.setAttribute('stroke-width', '2')
    path.setAttribute('stroke-linecap', 'round')
    path.setAttribute('stroke-linejoin', 'round')


    const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect')
    rect.setAttribute('x', '-33.5')
    rect.setAttribute('y', '-37')
    rect.setAttribute('width', '98')
    rect.setAttribute('height', '98')
    rect.setAttribute('stroke', color)
    rect.setAttribute('stroke-width', '2')

    g.append(path, rect)

    const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs')
    const clipPath = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath')
    clipPath.id = "clip0_4795_12551"
    const clipRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect')
    clipRect.setAttribute('width', '24')
    clipRect.setAttribute('fill', 'white')
    clipRect.setAttribute('transform', 'translate(0.5)')
    clipRect.setAttribute('height', '24')
    clipPath.append(clipRect)
    defs.append(clipPath)
    svg.append(g, defs)
    return svg
}
export const createRotateIcon = (color: string = 'var(--primary, #2251CC)') => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('viewBox', '0 0 24 24')
    svg.setAttribute('fill', 'none')
    svg.setAttribute('width', '24')
    svg.setAttribute('height', '24')

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttribute('d', 'M4.88672 3C4.88672 2.44772 4.439 2 3.88672 2C3.33443 2 2.88672 2.44772 2.88672 3V9C2.88672 9.55228 3.33443 10 3.88672 10H9.88672C10.439 10 10.8867 9.55228 10.8867 9C10.8867 8.44772 10.439 8 9.88672 8H6.2547C7.51965 6.18652 9.62127 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.86393 19 6.20952 16.9377 5.31899 14.0953C5.17164 13.625 4.75689 13.2696 4.26403 13.2696C3.64344 13.2696 3.16247 13.8215 3.32892 14.4194C4.38569 18.2149 7.86761 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C9.10723 3 6.53321 4.36479 4.88672 6.48559V3Z')
    path.setAttribute('fill', color)

    svg.append(path)
    return svg
}

export const createChevronLeftIcon = () => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('viewBox', '0 0 24 24')
    svg.setAttribute('fill', 'none')
    svg.setAttribute('width', '24')
    svg.setAttribute('height', '24')

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttribute('d', 'M15 18L9 12L15 6')
    path.setAttribute('stroke', '#434F61')
    path.setAttribute('stroke-width', '2')
    path.setAttribute('stroke-linecap', 'round')
    path.setAttribute('stroke-linejoin', 'round')

    svg.append(path)
    return svg
}

export const createCloseIcon = (color: string = '#434F61') => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('viewBox', '0 0 24 24')
    svg.setAttribute('fill', 'none')
    svg.setAttribute('width', '24')
    svg.setAttribute('height', '24')

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttribute('d', 'M18 6L6 18M6 6L18 18')
    path.setAttribute('stroke', color)
    path.setAttribute('stroke-width', '2')
    path.setAttribute('stroke-linecap', 'round')
    path.setAttribute('stroke-linejoin', 'round')

    svg.append(path)
    return svg
}

export const createEyeIcon = (color: string = '#2251CC') => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('viewBox', '0 0 24 24')
    svg.setAttribute('fill', 'none')
    svg.setAttribute('width', '24')
    svg.setAttribute('height', '24')

    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path1.setAttribute('d', 'M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z')
    path1.setAttribute('stroke', color)
    path1.setAttribute('stroke-width', '2')
    path1.setAttribute('stroke-linecap', 'round')
    path1.setAttribute('stroke-linejoin', 'round')

    const path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path2.setAttribute('d', 'M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z')
    path2.setAttribute('stroke', color)
    path2.setAttribute('stroke-width', '2')
    path2.setAttribute('stroke-linecap', 'round')
    path2.setAttribute('stroke-linejoin', 'round')

    svg.append(path1, path2)
    return svg
}

export const createTrashIcon = (color: string = 'white') => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('viewBox', '0 0 23 22')
    svg.setAttribute('fill', 'none')
    svg.setAttribute('width', '23')
    svg.setAttribute('height', '22')

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttribute('d', 'M3.16754 5.54554H4.98572M4.98572 5.54554H19.5312M4.98572 5.54554V18.2728C4.98572 18.755 5.17728 19.2175 5.51826 19.5585C5.85923 19.8994 6.32169 20.091 6.80391 20.091H15.8948C16.377 20.091 16.8395 19.8994 17.1805 19.5585C17.5214 19.2175 17.713 18.755 17.713 18.2728V5.54554M7.713 5.54554V3.72736C7.713 3.24515 7.90455 2.78269 8.24553 2.44171C8.5865 2.10074 9.04897 1.90918 9.53118 1.90918H13.1675C13.6498 1.90918 14.1122 2.10074 14.4532 2.44171C14.7942 2.78269 14.9857 3.24515 14.9857 3.72736V5.54554M9.53118 10.091V15.5455M13.1675 10.091V15.5455')
    path.setAttribute('stroke', color)
    path.setAttribute('stroke-width', '1.5')
    path.setAttribute('stroke-linecap', 'round')
    path.setAttribute('stroke-linejoin', 'round')

    svg.append(path)
    return svg
}

export const createInfoIcon = (status: 'ok' | 'warning' | 'error') => {
    const fillColor =
        status === 'ok'
            ? "var(--ok-icon-color, #31B237)"
            : status === 'warning'
                ? 'var(--warning-icon-color, #E9B949)'
                : 'var(--error-icon-color, #C53030)'

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('viewBox', '0 0 22 22')
    svg.setAttribute('fill', 'none')
    svg.setAttribute('width', '22')
    svg.setAttribute('height', '22')

    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path1.setAttribute('d', 'M10.9999 18.6756C15.2363 18.6756 18.6707 15.2412 18.6707 11.0048C18.6707 6.76831 15.2363 3.33398 10.9999 3.33398C6.76343 3.33398 3.3291 6.76831 3.3291 11.0048C3.3291 15.2412 6.76343 18.6756 10.9999 18.6756Z')
    path1.setAttribute('fill', fillColor)
    path1.setAttribute('fill-rule', 'evenodd')
    path1.setAttribute('clip-rule', 'evenodd')
    svg.append(path1)

    if (status === 'ok') {
        const path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path')
        path2.setAttribute('d', 'M8.5 11.0048L10.3255 12.9264C10.3657 12.9686 10.4333 12.9677 10.4723 12.9244L14 9.00476')
        path2.setAttribute('stroke', 'white')
        path2.setAttribute('stroke-width', '1.5')
        path2.setAttribute('stroke-linecap', 'round')
        path2.setAttribute('stroke-linejoin', 'round')
        svg.append(path2)
    } else {
        const path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path')
        path2.setAttribute('d', 'M10.2329 7.55291C10.2329 7.12926 10.5763 6.78583 11 6.78583C11.4236 6.78583 11.7671 7.12926 11.7671 7.55291V11.3883C11.7671 11.8119 11.4236 12.1554 11 12.1554C10.5763 12.1554 10.2329 11.8119 10.2329 11.3883V7.55291Z')
        path2.setAttribute('fill', '#FFF5F5')

        const path3 = document.createElementNS('http://www.w3.org/2000/svg', 'path')
        path3.setAttribute('d', 'M11.7671 14.4566C11.7671 14.8803 11.4236 15.2237 11 15.2237C10.5763 15.2237 10.2329 14.8803 10.2329 14.4566C10.2329 14.033 10.5763 13.6895 11 13.6895C11.4236 13.6895 11.7671 14.033 11.7671 14.4566Z')
        path3.setAttribute('fill', '#FFF5F5')

        svg.append(path2, path3)
    }

    return svg
}

export const createFullscreenIcon = (color: string = 'white') => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('viewBox', '0 0 23 22')
    svg.setAttribute('fill', 'none')
    svg.setAttribute('width', '23')
    svg.setAttribute('height', '22')

    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path1.setAttribute('d', 'M10.8813 16.6186L5.73873 16.6186M5.73873 16.6186L5.73873 11.4921M5.73873 16.6186L16.3843 6.00627')
    path1.setAttribute('stroke', color)
    path1.setAttribute('stroke-width', '1.36364')
    path1.setAttribute('stroke-linecap', 'round')
    path1.setAttribute('stroke-linejoin', 'round')

    const path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path2.setAttribute('d', 'M11.8174 5.38138H16.96V10.5079')
    path2.setAttribute('stroke', color)
    path2.setAttribute('stroke-width', '1.36364')
    path2.setAttribute('stroke-linecap', 'round')
    path2.setAttribute('stroke-linejoin', 'round')

    svg.append(path1, path2)
    return svg
}

export const createEllipsIcon = (color: string = '#CBD5E0') => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('viewBox', '0 0 4 4')
    svg.setAttribute('fill', 'none')
    svg.setAttribute('width', '4')
    svg.setAttribute('height', '4')

    const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle')
    circle.setAttribute('fill', color)
    circle.setAttribute('cx', '2')
    circle.setAttribute('cy', '2')
    circle.setAttribute('r', '2')

    svg.append(circle)
    return svg
}

export const createLegendLine = (color: string) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('viewBox', '0 0 59 2')
    svg.setAttribute('fill', 'none')
    svg.setAttribute('width', '59')
    svg.setAttribute('height', '2')

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttribute('d', 'M1 1H57.9294')
    path.setAttribute('stroke', color)
    path.setAttribute('stroke-width', '2')
    path.setAttribute('stroke-linecap', 'round')
    if (!window.enfocus)
        path.setAttribute('stroke-dasharray', '10 10')

    svg.append(path)
    return svg
}

export const createArrowBottomCircle = (color: string = 'var(--gray-500, #A0AEC0)') => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('viewBox', '0 0 25 24')
    svg.setAttribute('fill', 'none')
    svg.setAttribute('width', '25')
    svg.setAttribute('height', '24')

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttribute('d', 'M12.5 8V16M12.5 16L15.5 13M12.5 16L9.5 13M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12Z')
    path.setAttribute('stroke', color)
    path.setAttribute('stroke-width', '1.5')
    path.setAttribute('stroke-linecap', 'round')
    path.setAttribute('stroke-linejoin', 'round')

    svg.append(path)
    return svg
}

export const createLayout = (layoutState: LayoutState, page?: CheckResResultPage, viewer?: boolean) => {
    const layout = document.createElement('div')
    layout.classList.add('layout')
    layout.style.aspectRatio = `${+layoutState.partData.size.width} / ${+layoutState.partData.size.height}`

    if (+layoutState.partData.size.width >= +layoutState.partData.size.height)
        layout.classList.add('landscape')
    else
        layout.classList.add('portrait')

    const previewImg = new Image()
    previewImg.src = (window.isDevBuild ? 'https://elnar.tippo.ru' : '') + (
        !page
            ? layoutState.uploadResData.preview
            : viewer
                ? page.bigPreview
                : page.preview
    )
    previewImg.alt = 'layout-preview'
    layout.append(previewImg)

    if (!window.enfocus) {
        const zones = document.createElement('div')
        zones.classList.add('zones')
        const saveZone = document.createElement('div')
        saveZone.classList.add('save')

        const cutZone = document.createElement('div')
        cutZone.classList.add('cut')
        zones.append(saveZone, cutZone)

        const resizeObserver = new ResizeObserver(([entry]) => {
            const aspectRatio = entry.contentRect.width / +layoutState.partData.size.width

            saveZone.style.inset = `${(+layoutState.partData.size.cutZoneHeight + +layoutState.partData.size.safeZone) * aspectRatio}px ${(+layoutState.partData.size.cutZoneWidth + +layoutState.partData.size.safeZone) * aspectRatio}px`
            cutZone.style.inset = `${+layoutState.partData.size.cutZoneHeight * aspectRatio}px ${+layoutState.partData.size.cutZoneWidth * aspectRatio}px`
        })
        resizeObserver.observe(layout)
        layout.append(zones)
    }


    if (!viewer && page && page.label && layoutState.partData.isMultiPage === '1') {
        layout.classList.add('with-label')
        const pageLabel = document.createElement('div')
        pageLabel.classList.add('page-label')
        pageLabel.textContent = page.label
        layout.append(pageLabel)
    }

    return layout
}

interface ModalProps {
    title: string
    subTitle: string
    submitText: string
    cancelText?: string
    action?: () => void
}

export const createModal = ({ title, subTitle, submitText, cancelText, action }: ModalProps, root: ShadowRoot | HTMLDivElement | null) => {
    const modal = document.createElement('div')

    const closeModal = () => {
        modal.classList.remove('visible')
        setTimeout(() => modal.remove(), 300)
    }

    modal.classList.add('modal-window')
    modal.onclick = e => {
        e.stopPropagation()
        closeModal()
    }

    const container = document.createElement('div')
    container.onclick = e => e.stopPropagation()

    const text = document.createElement('div')
    const titleContainer = document.createElement('span')
    titleContainer.textContent = title
    const subTitleContainer = document.createElement('div')
    subTitleContainer.textContent = subTitle
    text.append(titleContainer, subTitleContainer)

    const actions = document.createElement('div')

    const submitBtn = document.createElement('button')
    submitBtn.classList.add('submit')
    submitBtn.textContent = submitText
    submitBtn.onclick = () => {
        if (action) action()
        closeModal()
    }

    actions.append(submitBtn)

    if (cancelText) {
        const cancelBtn = document.createElement('button')
        cancelBtn.classList.add('cancel')
        cancelBtn.textContent = cancelText
        cancelBtn.onclick = closeModal
        actions.append(cancelBtn)
    }

    const closeBtn = document.createElement('button')
    closeBtn.classList.add('close')
    closeBtn.append(createCloseIcon('var(--gray-800, #2D3748)'))
    closeBtn.onclick = closeModal


    container.append(text, actions, closeBtn)
    modal.append(container)
    root?.append(modal)
    setTimeout(() => modal.classList.add('visible'))
}

export const addEmptyLayout = (constiner: HTMLDivElement, name: string, index: number) => {
    const emptyLayout = document.createElement('div')
    emptyLayout.classList.add('layout-type', 'empty')

    const span = document.createElement('span')
    const b = document.createElement('b')
    b.textContent = name.toUpperCase()
    span.append(b, ` ВИД ${index}`)
    emptyLayout.append(span, 'Макет появится после загрузки и проверки')

    constiner.append(emptyLayout)
}